module.exports = __webpack_public_path__ + "img/scene-25.2b0a9551.png";